import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email('Ingresa un correo válido')
    .required('Ingresa tu correo electrónico'),
  password: Yup.string()
    .required('Ingresa tu contraseña')
});
